// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__19xuw","inputWrap":"CustomTip_inputWrap__2wdjT"};